if(!customElements.get("cart-recommend")){
    customElements.define("cart-recommend",class CartRecommend extends HTMLElement {

        constructor(){
            super();
              this.productRecommendationsSection = document.querySelector('.drawer__product-recommend');
              this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'});
              this.swatches = this.querySelectorAll("[data-grid-swatches]");
              
              this.observer.observe(this);
        }
       
        swatchInit(){
          
        }
        handleIntersection(entries, observer){
            if (!entries[0].isIntersecting) return;
        
            observer.unobserve(this);
        
            const url = this.dataset.url;
            console.log("url",url);
            fetch(url)
              .then(response => response.text())
              .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('cart-recommend [data-recommend-list]');
                console.log("recommendations",recommendations);
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.querySelector("[data-recommend-list]").innerHTML = recommendations.innerHTML;
                }
              })
              .catch(e => {
                console.error(e);
              });
          };

    })
}


